document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".custom-button img");

    buttons.forEach((button) => {
        const fullSrc = button.getAttribute("src");
        const [baseSrc, query] = fullSrc.split("?");
        const hoverSrc = baseSrc.replace(".svg", "-hov.svg") + (query ? "?" + query : "");

        button.addEventListener("mouseenter", () => {
            button.setAttribute("src", hoverSrc);
        });

        button.addEventListener("mouseleave", () => {
            button.setAttribute("src", fullSrc);
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {
  const openBtns = document.querySelectorAll('.modal-trigger');
  const modals = document.querySelectorAll('.info-modal');
  const closeBtns = document.querySelectorAll('.info-modal-close');
  const claimBtns = document.querySelectorAll('.info-modal-claim');

  openBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const modalId = btn.getAttribute('data-modalId');
      const modal = document.getElementById(modalId);
      console.log('clicked');
      modal.style.display = 'flex';
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const modal = btn.closest('.info-modal');
      modal.style.display = 'none';
    });
  });

  claimBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = btn.closest('.info-modal');
      modal.style.display = 'none';
    });
  });

  window.addEventListener('click', (e) => {
    modals.forEach(modal => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    })
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      modals.forEach(modal => {
        if (modal.style.display === 'flex') {
          modal.style.display = 'none';
        }
      });
    }
  });
});
